import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { InboxesViewProvider } from 'pages/settings/pages/inboxes/context/inboxesViewContext'

const InboxesPageLayoutContent = () => {
  return <Outlet />
}

export const InboxesPageLayout = observer(() => {
  return (
    <InboxesViewProvider>
      <InboxesPageLayoutContent />
    </InboxesViewProvider>
  )
})
